var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLgoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #000;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 50px;\n      }\n\n      .st1 {\n        stroke: #d47500;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M709.3,213.3l-318,318c-31.7,31.7-125.7,46.3-146.7,25.3-21-21-6.7-115,25-146.7L588,91.7c7.9-8.6,17.4-15.4,27.9-20.2,10.6-4.8,22-7.4,33.6-7.6,11.6-.2,23.2,1.9,33.9,6.2,10.8,4.3,20.6,10.8,28.8,19,8.2,8.2,14.7,18,19,28.8,4.3,10.8,6.4,22.3,6.1,34-.3,11.6-2.9,23.1-7.7,33.6-4.8,10.6-11.7,20.1-20.3,27.9h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.7,133.3h-166.7c-35.4,0-69.3,14-94.3,39.1-25,25-39.1,58.9-39.1,94.3v333.3c0,35.4,14,69.3,39.1,94.3,25,25,58.9,39.1,94.3,39.1h366.7c73.7,0,100-60,100-133.3v-166.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgoEdit);
export default __webpack_public_path__ + "static/media/LGO_Edit.96d4c5dcacdb292b33ca237c1e020fa2.svg";
export { ForwardRef as ReactComponent };